<div class="container-fluid">
    <div class="">
        <div class="pt-4 make-smol">
            <app-load-loans></app-load-loans>
        </div>
    </div>
</div>
<!-- <div>
    <button mat-fab class="form-button-right" style="box-shadow: none;" type="submit" (click)="save()"><i class="fa fa-arrow-right" ></i></button>
</div> -->